import React from 'react'
import TenantTableItem from "./TenantTableItem"

const TenantTableBody = (props) => {
    const {error, listTenantParam} = props

    return (
        <tbody className="TableBody">
        {
            listTenantParam && listTenantParam.length > 0 ? listTenantParam.map((item, index) => (
                <TenantTableItem
                    item={item}
                />
            )) : <tr className="NoRecord">
                <td colSpan={6}>Không có bản ghi nào</td>
            </tr>
        }

        {
            error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={6}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default TenantTableBody